<template>
  <button @click="getAuthCode()">Sign in/Log in using Google</button>
</template>

<script>
export default {
  name: "GoogleLogin",

  methods: {
    getAuthCode() {
      console.log("client", this.client);
      this.client.requestCode();
    },
    initClient() {
      this.client = google.accounts.oauth2.initCodeClient({
        client_id: this.client_id,
        scope: this.scope,
        ux_mode: this.ux_mode,
        callback: (response) => {
          console.log("initClient", response);
          this.apiLogIn(response.code);
        },
      });
    },
    apiLogIn(token) {
      fetch("https://oraiappv2.tryoratio.com/mobileapp/v2/signup/social", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Provider: "google",
          Code: token,
          RedirectURI: window.location.origin,
          Query:
            "query User { me { doneJourneyOnboarding uid name email provider age language gender profession anon } }",
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          console.log("JWT:", response.headers.get("Authentication"));
          this.jwt_token = response.headers.get("Authentication");
          return response.json();
        })
        .then((responseJSON) => {
          //console.log(responseJSON);
          //alert("logged in successfully: " + responseJSON.data.me.name);
          this.$emit("onLogin", {
            jwt: this.jwt_token,
            user: responseJSON.data.me,
          });
        })
        .catch((error) => {
          console.error("error:", error);
        });
    },
  },
  data() {
    return {
      client_id:
        "556855616197-816o0ced9equ4hs3t00d7o4s44pbocmg.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/userinfo.profile",
      ux_mode: "popup",
      client: null,
      jwt_token: null,
    };
  },

  mounted() {
    let googleScript = document.createElement("script");
    googleScript.setAttribute("src", "https://accounts.google.com/gsi/client");
    document.head.appendChild(googleScript);
    googleScript.onload = () => {
      console.log("google script loaded");
      this.initClient();
    };
  },
};
</script>
